/**
 * Format a Firestore timestamp or date string for display
 */
export function formatDate(timestamp) {
  if (!timestamp) return ''

  let date
  // Handle Firestore Timestamp format (serialized as {_seconds, _nanoseconds})
  if (timestamp._seconds) {
    date = new Date(timestamp._seconds * 1000)
  } else if (timestamp.seconds) {
    date = new Date(timestamp.seconds * 1000)
  } else if (timestamp.toDate) {
    date = timestamp.toDate()
  } else {
    date = new Date(timestamp)
  }

  // Check for invalid date
  if (isNaN(date.getTime())) return ''

  return date.toLocaleDateString()
}

/**
 * Format a timestamp as relative time (e.g., "5m ago", "2h ago")
 */
export function formatRelativeTime(timestamp) {
  if (!timestamp) return ''

  let date
  if (timestamp._seconds) {
    date = new Date(timestamp._seconds * 1000)
  } else if (timestamp.seconds) {
    date = new Date(timestamp.seconds * 1000)
  } else if (timestamp.toDate) {
    date = timestamp.toDate()
  } else {
    date = new Date(timestamp)
  }

  if (isNaN(date.getTime())) return ''

  const now = new Date()
  const diff = now - date

  if (diff < 60000) return 'Just now'
  if (diff < 3600000) return `${Math.floor(diff / 60000)}m ago`
  if (diff < 86400000) return `${Math.floor(diff / 3600000)}h ago`
  return date.toLocaleDateString()
}

/**
 * Format time for messages (shows time today, day of week this week, date otherwise)
 */
export function formatMessageTime(timestamp) {
  if (!timestamp) return ''

  let date
  if (timestamp._seconds) {
    date = new Date(timestamp._seconds * 1000)
  } else if (timestamp.seconds) {
    date = new Date(timestamp.seconds * 1000)
  } else if (timestamp.toDate) {
    date = timestamp.toDate()
  } else {
    date = new Date(timestamp)
  }

  if (isNaN(date.getTime())) return ''

  const now = new Date()
  const diff = now - date

  if (diff < 86400000) {
    return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
  }
  if (diff < 604800000) {
    return date.toLocaleDateString([], { weekday: 'short' })
  }
  return date.toLocaleDateString()
}
